export const LONDON_TIMESTAMP = new Date("2021-08-05T00:00:00Z");
